module.exports = __webpack_public_path__ + "static/media/1124_Backstrap_1K.0fe4926b.glb";